const PencilIcon = ({ color = 'black' }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.04997 12.7902C4.73997 13.1202 4.43997 13.7702 4.37997 14.2202L4.00997 17.4602C3.87997 18.6302 4.71997 19.4302 5.87997 19.2302L9.09997 18.6802C9.54997 18.6002 10.18 18.2702 10.49 17.9302L18.7 9.24022C20.12 7.74022 20.76 6.03022 18.55 3.94022C16.35 1.87022 14.68 2.60022 13.26 4.10022L5.04997 12.7902Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.89 5.5498C12.32 8.3098 14.56 10.4198 17.34 10.6998"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22.5H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PencilIcon;
